var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaused = function SvgPaused(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10.5,
    height: 10.5,
    x: 0.75,
    y: 0.75,
    stroke: "#FF4D00",
    strokeDasharray: "3 3",
    strokeWidth: 1.5,
    rx: 3.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 6,
    x: 3,
    y: 3,
    fill: "#FF4D00",
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 6,
    x: 7,
    y: 3,
    fill: "#FF4D00",
    rx: 1
  })));
};
export default SvgPaused;